import { useTranslation } from 'react-i18next';

const benefits = [
  { icon: 'ri-time-line', key: 'about.benefit1' },
  { icon: 'ri-shield-check-line', key: 'about.benefit2' },
  { icon: 'ri-refresh-line', key: 'about.benefit3' },
  { icon: 'ri-group-line', key: 'about.benefit4' },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Left: Image */}
          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20home%20office%20desk%20setup%20with%20an%20iMac%20displaying%20a%20neatly%20organized%20spreadsheet%20interface%2C%20a%20small%20potted%20olive%20plant%20in%20a%20ceramic%20pot%2C%20a%20moleskine%20notebook%20and%20a%20black%20pen%2C%20warm%20natural%20light%20from%20a%20window%20on%20the%20right%2C%20light%20wooden%20desk%20surface%2C%20cream%20walls%2C%20Scandinavian%20interior%20design%2C%20minimal%20and%20clean%20aesthetic%2C%20soft%20and%20airy%20atmosphere%2C%20editorial%20photography%20with%20gentle%20shadows&width=800&height=1000&seq=about-kakobuy-v3&orientation=portrait"
                alt="Kakobuy Spreadsheet w użyciu"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:col-span-7">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
              {t('about.title')}
            </h2>
            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
              {t('about.desc1')}
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {t('about.desc2')}
            </p>

            {/* Benefits */}
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((benefit) => (
                <div key={benefit.key} className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-600 flex-shrink-0">
                    <i className={`${benefit.icon} text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800">
                    {t(benefit.key)}
                  </span>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta.primary')}
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}